import {
  isReportDimensionCompatible,
  isReportMetricCompatible,
  reportDimensionConflicts,
  reportMetricConflicts,
  type ReportSelectionConflicts,
} from '../../compatibility';
import { reportDimensionLabel, reportMetricLabel } from '../../format';
import type { ReportExplorerConfiguration, ReportFilter } from '../../model';
import type { ReportDimension, ReportMetric } from '../../reportEnums';
import { dashboardT } from '../../../../../lib/messages';

/** Availability and "why disabled" text for the field rail against the current table selection. */
export function reportFieldRailRules(
  config: Pick<ReportExplorerConfiguration, 'tableDimensions' | 'tableMetrics'>,
  filters: Partial<ReportFilter>,
) {
  const { tableDimensions, tableMetrics } = config;
  return {
    isDimensionDisabled: (candidate: ReportDimension) =>
      !isReportDimensionCompatible(candidate, tableDimensions, tableMetrics, filters),
    isMetricDisabled: (candidate: ReportMetric) =>
      !isReportMetricCompatible(candidate, tableMetrics, tableDimensions, filters),
    dimensionDisabledReason: (candidate: ReportDimension) =>
      reportConflictMessage(
        reportDimensionConflicts(candidate, tableDimensions, tableMetrics, filters),
      ),
    metricDisabledReason: (candidate: ReportMetric) =>
      reportConflictMessage(
        reportMetricConflicts(candidate, tableMetrics, tableDimensions, filters),
      ),
  };
}

export function reportConflictMessage(conflicts: ReportSelectionConflicts) {
  const items = [
    ...conflicts.dimensions.map(reportDimensionLabel),
    ...conflicts.metrics.map(reportMetricLabel),
  ];
  if (items.length) {
    return dashboardT('reportExplorer.fields.unavailableWith', { items: items.join(', ') });
  }
  return dashboardT(
    conflicts.filters
      ? 'reportExplorer.fields.unavailableFilters'
      : 'reportExplorer.fields.unavailable',
  );
}
